import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, FlexRow } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { capitalize, formatLocale } from '@/modules/shared/helpers/locale'
import { StIconContainer } from '../TimelineToday.styled'

const EmptyCard = () => {
  const theme = useTheme()

  return (
    <FlexRow flexGrow={1} justifyContent='center' alignItems='center'>
      <FlexColumn alignItems='center' gap={theme.UI.Spacing.Space4}>
        <StIconContainer>
          <img src='/img/svg/checklist-empty.svg' alt='' />
        </StIconContainer>
        <H2 noMargin>{capitalize(formatLocale(new Date(), 'EEEE d MMMM'))}</H2>
        <FlexColumn justifyContent='center'>
          <Span type='BodyLargeRegular' color={theme.Colors.Neutrals.Darker}>
            {t({
              id: 'home.task-card.tasks-today.empty',
              message: 'Je hebt niets gepland vandaag',
            })}
          </Span>
        </FlexColumn>
      </FlexColumn>
    </FlexRow>
  )
}

export { EmptyCard }
